import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take} from 'rxjs/operators';

import {
  DobryAgentBlogArticle,
  DobryAgentBlogCategory
} from '../../../../shared/interface/dobry-agent-blog-article';
import {
  DobryAgentBlogCategoryService
} from '../../../../shared/services/dobry-agent-blog-category.service';

@Component({
  selector: 'app-da-category-article-order',
  templateUrl: './da-category-article-order.component.html',
  styleUrls: ['./da-category-article-order.component.scss']
})
export class DaCategoryArticleOrderComponent implements OnChanges {
  @Input() blogCategory?: DobryAgentBlogCategory;

  articles: DobryAgentBlogArticle[] = [];

  saving = false;
  changed = false;

  constructor(
    private blogCategoryService: DobryAgentBlogCategoryService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.blogCategory) {
      this.setArticles();
    }
  }

  drop(
    event: CdkDragDrop<DobryAgentBlogArticle[]>
  ): void {
    if (
      event.previousIndex === event.currentIndex
      || this.saving
    ) {
      return;
    }

    moveItemInArray(
      this.articles,
      event.previousIndex,
      event.currentIndex
    );

    this.recalculatePositions();

    this.changed = true;
  }

  save(): void {
    if (
      !this.blogCategory?.uuid
      || !this.changed
      || this.saving
    ) {
      return;
    }

    this.saving = true;

    const articleUuids = this.articles.map(
      article => article.uuid
    );

    this.blogCategoryService
      .updateArticleOrder(
        this.blogCategory.uuid,
        articleUuids
      )
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.saving = false;
          this.changed = false;

          this.snack.open(
            'Kolejność artykułów została zapisana.',
            '',
            {duration: 2000}
          );
        },
        error: () => {
          this.saving = false;

          this.snack.open(
            'Nie udało się zapisać kolejności artykułów.',
            '',
            {duration: 3000}
          );
        }
      });
  }

  reset(): void {
    this.setArticles();
  }

  trackByUuid(
    index: number,
    article: DobryAgentBlogArticle
  ): string {
    return article.uuid;
  }

  private setArticles(): void {
    this.articles = [
      ...(this.blogCategory?.blogArticles ?? [])
    ].sort(
      (
        first: DobryAgentBlogArticle,
        second: DobryAgentBlogArticle
      ) => {
        return (first.position ?? 0) - (second.position ?? 0);
      }
    );

    this.recalculatePositions();

    this.changed = false;
  }

  private recalculatePositions(): void {
    this.articles = this.articles.map(
      (
        article: DobryAgentBlogArticle,
        index: number
      ) => ({
        ...article,
        position: index + 1
      })
    );
  }
}
